<button class="kt-btn kt-btn-ghost kt-btn-icon size-9 rounded-full hover:bg-transparent hover:[&amp;_i]:text-primary"
	data-kt-drawer-toggle="#notifications_drawer">
	<i class="ki-filled ki-notification-status text-lg">
	</i>
</button>